import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { AuthContext } from '../context/AuthContext';

const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 996;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  right: ${props => props.$isOpen ? '0' : '-280px'};
  width: 280px;
  height: 100%;
  background: white;
  z-index: 997;
  padding: 80px 30px 40px;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  color: #2E2E2E;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 0.7;
  }
`;

const NavLink = styled(Link)`
  color: rgba(46, 46, 46, 0.7);
  text-decoration: none;
  font-size: 18px;
  margin: 12px 0;
  transition: color 0.2s ease;
  text-transform: lowercase;

  &:hover, &.active {
    color: #2E2E2E;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid rgba(46, 46, 46, 0.1);
  margin: 20px 0;
  width: 100%;
`;

const MobileMenu = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { user } = React.useContext(AuthContext);

  return (
    <>
      <MenuOverlay $isOpen={isOpen} onClick={onClose} />
      <MenuContainer $isOpen={isOpen}>
        <CloseButton onClick={onClose}>
          <FaTimes />
        </CloseButton>
        
        <NavLink to="/" className={location.pathname === '/' ? 'active' : ''} onClick={onClose}>
          search
        </NavLink>
        <NavLink to="/collections" className={location.pathname === '/collections' ? 'active' : ''} onClick={onClose}>
          collections
        </NavLink>
        <NavLink to="/about" className={location.pathname === '/about' ? 'active' : ''} onClick={onClose}>
          about
        </NavLink>
        <NavLink to="/blog" className={location.pathname === '/blog' ? 'active' : ''} onClick={onClose}>
          blog
        </NavLink>
        <Divider />
        <NavLink to="/pricing" className={location.pathname === '/pricing' ? 'active' : ''} onClick={onClose}>
          pricing
        </NavLink>
        {user ? (
          <NavLink to="/user" className={location.pathname === '/user' ? 'active' : ''} onClick={onClose}>
            my account
          </NavLink>
        ) : (
          <NavLink to="/login" className={location.pathname === '/login' ? 'active' : ''} onClick={onClose}>
            login
          </NavLink>
        )}
      </MenuContainer>
    </>
  );
};

export default MobileMenu; 